import React, { useEffect } from 'react';
import { Result, Spin } from 'antd';

const StripeAccountLinkRefreshPage = () => {
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // Simulate a brief loading state
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Result
        status="warning"
        title="Account Setup Incomplete"
        subTitle="The account setup link has expired or needs to be refreshed. Please try again to complete your account setup."
      />
    </div>
  );
};

export default StripeAccountLinkRefreshPage;
